import { Box, Stack, Typography } from '@mui/material';

import { FSCard } from '@/ui/components/FSCard';
import { ColorsRaw } from '@/ui/theme/colors-raw';

export function ProjectVenueCard({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <FSCard
      sx={{
        p: 3,
        backgroundColor: ColorsRaw.anthracite.Anthracite_3,
        borderColor: ColorsRaw.anthracite.Anthracite_3,
        height: '100%',
      }}
    >
      <Stack sx={{ gap: 2 }}>
        <Typography sx={{ fontSize: '1.5rem', fontWeight: '800' }}>
          {title}
        </Typography>
        <Box>{children}</Box>
      </Stack>
    </FSCard>
  );
}
